import { of } from "rxjs";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
export var pathHandleFbConnectError = function () {
    return of(actionModalOpen(IdModal.FacebookConnectFailure));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/facebook/pathHandleFbConnectError.ts
// module id = 1853
// module chunks = 3